import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionWrapper } from '../../components/Section'
import CircularProgress from '../../components/CircularProgress'
import SuccessMessage from '../../components/SuccessMessage'
import messages from './messages'

function AccountVerificationRequesting() {
  return (
    <SectionWrapper align='center'>
      <CircularProgress size={80} />
      <SuccessMessage>
        <FormattedMessage {...messages.requesting} />
      </SuccessMessage>
    </SectionWrapper>
  )
}

export default AccountVerificationRequesting
